module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp23_7005.be5c50b5.png";